// src/components/sale-page/AreaAskNotice.tsx
// การ์ดแจ้งเตือน "พื้นที่จัดส่งพิเศษ" บนเซลเพจ — แยกเป็นการ์ดสีแดงตัวใหญ่ของตัวเอง
// (requirement 2026-09-08: เดิมเป็นข้อความเล็กสีส้มใต้บรรทัดค่าส่ง มองข้ามง่าย)
// ใช้ร่วมกัน InlineCheckout + หน้า /checkout + หน้าขอบคุณ — แก้ที่นี่ที่เดียว
//
// พื้นที่นี้ลูกค้าต้องเคลียร์ค่าส่งกับแอดมินก่อน จึง "ยังไม่ให้โอน/แนบสลิป/เห็นบัญชี"
// (ผู้เรียกซ่อนบัญชี+ช่องสลิปเอง แล้วส่ง transfer=true มาให้การ์ดนี้บอกลูกค้า)

'use client'

import { DEFAULT_AREA_ASK_MESSAGE } from '@/lib/services/shippingService'

interface Props {
  /** ข้อความของร้าน (Shop.areaAskMessage) — ว่าง = ข้อความมาตรฐาน */
  message?: string | null
  /** ลูกค้าเลือกโอนเงิน → เพิ่มบรรทัด "ยังไม่ต้องโอน/แนบสลิป" */
  transfer?: boolean
  className?: string
}

function splitLines(message: string): string[] {
  return message.replace(/<br\s*\/?>/gi, '\n').split('\n')
}

export default function AreaAskNotice({ message, transfer, className }: Props) {
  const lines = splitLines((message ?? '').trim() || DEFAULT_AREA_ASK_MESSAGE)
  return (
    <div
      role="alert"
      className={`rounded-2xl border-2 border-red-300 bg-red-50 p-4 sm:p-5 ${className ?? ''}`}
    >
      <div className="flex items-start gap-3">
        <div className="shrink-0 w-11 h-11 rounded-full bg-red-100 flex items-center justify-center">
          <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.2} d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
          </svg>
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-lg font-bold text-red-700 leading-tight">พื้นที่จัดส่งพิเศษ — ต้องยืนยันค่าจัดส่งกับแอดมินก่อน</p>
          <p className="mt-2 text-[15px] text-red-800 leading-relaxed">
            {lines.map((line, i) => (
              <span key={i}>
                {line}
                {i < lines.length - 1 && <br />}
              </span>
            ))}
          </p>
          {transfer && (
            <p className="mt-3 text-sm font-semibold text-red-700 bg-white/70 rounded-lg px-3 py-2">
              ยังไม่ต้องโอนเงินหรือแนบสลิปตอนนี้ — แอดมินจะแจ้งเลขบัญชีและยอดที่ต้องชำระให้หลังยืนยันค่าจัดส่งแล้ว
            </p>
          )}
        </div>
      </div>
    </div>
  )
}
